import aeroSafeLogo from "../assets/images/logos/logo_aerosafe.jpg";
import arcadiaLogo from "../assets/images/logos/logo_arcadia.jpg";
import aitiaLogo from "../assets/images/logos/logo_aitia.png";
import baseImmuneLogo from "../assets/images/logos/logo_baseimmune.jpg";
import cancerIqLogo from "../assets/images/logos/logo_canceriq.png";
import clearDataLogo from "../assets/images/logos/logo_cleardata.jpg";
import datavantLogo from "../assets/images/logos/logo_datavant.png";
import evaxionLogo from "../assets/images/logos/logo_evaxion.jpg";
import infectiousDiseaseLogo from "../assets/images/logos/logo_infectious_disease.jpg";
import koneksaLogo from "../assets/images/logos/logo_koneksa.jpg";
import octaveLogo from "../assets/images/logos/logo_octave.jpg";
import pathAiLogo from "../assets/images/logos/logo_pathai.jpg";
import pragmaBioLogo from "../assets/images/logos/logo_pragmaBio.jpg";
import preciseDxLogo from "../assets/images/logos/logo_precisedx.jpg";
import prognosLogo from "../assets/images/logos/logo_prognos.jpg";
import rxVantageLogo from "../assets/images/logos/logo_rxvantage.jpg";
import saamaLogo from "../assets/images/logos/logo_saama.jpg";
import strataLogo from "../assets/images/logos/logo_strata.jpg";
import tagNTracLogo from "../assets/images/logos/logo_tagNTrac.jpg";
import tassoLogo from "../assets/images/logos/logo_tasso.jpg";
import transcarentLogo from "../assets/images/logos/logo_transcarent.jpg";
import transvoyantLogo from "../assets/images/logos/logo_transvoyant.jpg";
import triNetXLogo from "../assets/images/logos/logo_trinetx.jpg";
import turbineLogo from "../assets/images/logos/logo_turbine.png";
import uniteUsLogo from "../assets/images/logos/logo_uniteus.jpg";
import unnaturalProductsLogo from "../assets/images/logos/logo_unnaturalproducts.jpg";
import veranaHealthLogo from "../assets/images/logos/logo_veranahealth.jpg";
import vergeGenomicsLogo from "../assets/images/logos/logo_vergegenomics.jpg";
import wellDocLogo from "../assets/images/logos/logo_welldoc.jpg";
import ashWellnessLogo from "../assets/images/logos/logo_ashwellness.jpg";
import artoposLogo from "../assets/images/logos/logo_atropos.jpg";
import cargosenseLogo from "../assets/images/logos/logo_cargosense.jpg";
import delfiLogo from "../assets/images/logos/logo_delfi.jpg";
import qureaiLogo from "../assets/images/logos/logo_qureai.jpg";
import npowerLogo from "../assets/images/logos/logo-npower.jpg";
import bighatLogo from "../assets/images/logos/logo-bighat.jpg";
import variationalLogo from "../assets/images/logos/logo-variational.jpg";
import zephyrLogo from "../assets/images/logos/logo-zephyr.jpg";
import redicaLogo from "../assets/images/logos/Redica_logo.jpg";
import emeraldLogo from "../assets/images/logos/ECL.jpg";
import protillionLogo from "../assets/images/logos/Protillion_logo.jpg";

const portfolio = [
  {
    name: "AeroSafe Global",
    description:
      "Delivers cold-chain services for the bio-pharma industry that result in zero temperature excursions for every client,every product, every time.",
    link: "http://www.aerosafeglobal.com/",
    image: aeroSafeLogo
  },
  {
    name: "Aitia",
    description: "Aitia is the leading causal AI company enabling the discovery of which patients respond to drugs and why.",
    link: "https://www.aitiabio.com/",
    image: aitiaLogo
  },
  {
    name: "Arcadia",
    description:
      "Arcadia Healthcare Solutions is a population health and analytics technology company supporting ambulatory networks taking on value-based risk and transitioning to managed care.",
    link: "http://www.arcadiasolutions.com/",
    image: arcadiaLogo
  },
  {
    name: "Ash Wellness",
    description: "End-to-end solution that allows organizations to offer at-home diagnostic testing to their customers and patients.",
    link: "https://www.poweredbyash.com/",
    image: ashWellnessLogo
  },
  {
    name: "Atropos Health",
    description: "Provides on-demand evidence from real world data to close evidence gaps in healthcare and life sciences.",
    link: "https://www.atroposhealth.com/",
    image: artoposLogo
  },
  {
    name: "Baseimmune",
    description: "Combining scientific expertise with our proprietary AI-platform to generate mutation-resistant vaccines.",
    link: "https://www.baseimmune.co.uk/",
    image: baseImmuneLogo
  },
  {
    name: "Bighat",
    description: "Designing safer, more effective antibody therapies for patients using machine learning and synthetic biology.",
    link: "https://www.bighatbio.com/",
    image: bighatLogo
  },
  {
    name: "CancerIQ",
    description: "Genetic cancer risk assessment.",
    link: "https://www.canceriq.com/",
    image: cancerIqLogo
  },
  {
    name: "CargoSense",
    description: "Supporting operational continuity through supply chain visibility.",
    link: "https://www.cargosense.com/",
    image: cargosenseLogo
  },
  {
    name: "ClearData",
    description:
      "Provide healthcare managed cloud and security platform integrated with AWS; healthcare exclusive, HIPAA-compliant, HITRUST CSF Certified.",
    link: "https://www.cleardata.com/",
    image: clearDataLogo
  },
  {
    name: "Datavant",
    description: "Connecting health care data.",
    link: "https://datavant.com/",
    image: datavantLogo
  },
  {
    name: "Delfi Diagnostics",
    description: "DELFI uses novel machine learning algorithms to analyze fragments of cell-free DNA.",
    link: "https://delfidiagnostics.com/",
    image: delfiLogo
  },
  {
    name: "Emerald Cloud Labs",
    description: "Emerald Cloud Lab (ECL) is a remote-controlled life science laboratory that lets scientists run experiments from anywhere using a web-based platform, powered by robotics, AI, and cloud computing to automate complex experiments like chromatography, mass spectrometry, and protein analysis, making research faster, more accessible, and cost-effective.",
    link: "http://www.emeraldcloudlab.com/",
    image: emeraldLogo
  },
  {
    name: "Evaxion",
    description: "Saving lives with AI-Immunology™ powered vaccines.",
    link: "https://www.evaxion-biotech.com/",
    image: evaxionLogo
  },
  {
    name: "Infectious Disease Connect",
    description:
      "Brings a team of world-class ID Specialists to hospitals in a cost-effective manner, providing primary expertise, back-fill support, or staff augmentation.",
    link: "http://www.idctelemed.com/",
    image: infectiousDiseaseLogo
  },
  {
    name: "Koneska",
    description: "Consistently and objectively captures patient reported outcomes and device data in clinical research.",
    link: "https://www.koneksahealth.com/",
    image: koneksaLogo
  },
  {
    name: "N-Power",
    description: "Partnering with oncologists to unlock the potential of clinical trials.",
    link: "https://www.npowermedicine.com",
    image: npowerLogo
  },
  {
    name: "Octave",
    description:
      "Octave is providing the first blood test to accurately measure disease activity at the biology level to personalize patient decision making.",
    link: "https://www.octavebio.com/",
    image: octaveLogo
  },
  {
    name: "PathAI",
    description:
      "PathAI is developing technology that assists pathologists in making rapid and accurate diagnoses for every patient, every time. Our technology promises to better diagnose—and treat—some of today's most challenging diseases.",
    link: "https://www.pathai.com/",
    image: pathAiLogo
  },
  {
    name: "Pragma Bio",
    description:
      "Leveraging advanced technologies in machine learning and synthetic biology to scale intelligent discovery with iterative biomanufacturing.",
    link: "http://www.pragmabio.com/",
    image: pragmaBioLogo
  },
  {
    name: "PreciseDx",
    description:
      "PreciseDx provides artificial intelligence guided pathology diagnostics to improve patient outcomes in the field of cancer and other diseases.",
    link: "https://precisedx.ai/",
    image: preciseDxLogo
  },
  {
    name: "Prognos",
    description: "Leveraging clinical data, analytics and artificial intelligence to drive the right decisions earlier to improve health.",
    link: "http://www.prognos.ai/",
    image: prognosLogo
  },
   {
    name: "Protillion Biosciences",
    description: "Protillion Biosciences‘ transformational drug discovery and optimization platform generates precise protein data with the scale to bridge advanced computation and real-world results. The platform can identify and optimize new protein therapeutics to accelerate R&D productivity.",
    link: "http://www.protillion.com/",
    image: protillionLogo
  },
  {
    name: "Qure AI",
    description:"AI powered reporting and seamless collaboration to make healthcare more accessible and equitable.",
    link: "https://www.qure.ai/",
    image: qureaiLogo
  },
  {
    name: "Redica Systems",
    description:"Redica is the Intelligence Cloud for quality and regulatory operations, transforming regulatory complexity into trusted, proactive intelligence.",
    link: "https://www.redica.com",
    image: redicaLogo
  },
  {
    name: "RxVantage",
    description:
      "Bringing education resources that life science companies create into an easy-to-use app that healthcare providers use to get the answers they need for patients.",
    link: "http://www.rxvantage.com/",
    image: rxVantageLogo
  },
  {
    name: "Saama",
    description:
      "AI clinical analytics platform company, enabling the life sciences industry to conduct faster and safer clinical development and regulatory programs.",
    link: "https://www.saama.com/",
    image: saamaLogo
  },
  {
    name: "Strata Oncology",
    description: "Strata Oncology is delivering a new way forward for precision oncology that is highly-scaled, systematic and data-driven.",
    link: "https://www.strataoncology.com/",
    image: strataLogo
  },
  {
    name: "Tag-N-Trac",
    description:
      "Provides a full stack IoT Platform as a Service (PaaS) startup offering turnkey solutions for Serialization, Continuous Inventory, Logistics, and Anomoly traceability.",
    link: "https://www.tagntrac.com/",
    image: tagNTracLogo
  },
  {
    name: "Tasso",
    description: "Tasso offers a reliable and scalable solution to continue blood testing without a face-to-face phlebotomy draw.",
    link: "http://www.tassoinc.com/",
    image: tassoLogo
  },
  {
    name: "Transcarent",
    description: "Transcarent is a consumer-directed health and care platform for employees of self-insured employers.",
    link: "https://transcarent.ai/",
    image: transcarentLogo
  },
  {
    name: "Transvoyant",
    description: "The leader in real-time actionable supply chain intelligence.",
    link: "https://transvoyant.com/",
    image: transvoyantLogo
  },
  {
    name: "TriNetX",
    description:
      "TriNetX is the global health research network that optimizes clinical research and enables discoveries through the creation of real-world evidence.",
    link: "https://www.trinetx.com/",
    image: triNetXLogo
  },
  {
    name: "Turbine",
    description: "In silico disease modeling.",
    link: "https://turbine.ai/",
    image: turbineLogo
  },
  {
    name: "Unite Us",
    description: "Unite Us is an outcome-focused technology company that builds coordinated care networks fo health and social service providers",
    link: "https://uniteus.com/",
    image: uniteUsLogo
  },
  {
    name: "Unnatural Products",
    description:
      "Unnactural Products' AI-enhanced drug discovery and development technology engineers entirely new drugs from passively permeable, macrocylic peptides.",
    link: "https://www.unnaturalproducts.com/",
    image: unnaturalProductsLogo
  },
  {
    name: "Variational",
    description: "Providing the first commercially accessible foundation model for small molecules.",
    link: "https://variational.ai",
    image: variationalLogo
  },
  {
    name: "Verana Health",
    description: "Verana Health is assembling the largest clinical databases in medicine to empower physicians and accelerate research for patients.",
    link: "https://www.veranahealth.com/",
    image: veranaHealthLogo
  },
  {
    name: "Verge Genomics",
    description: "Next-generation meidicines from human genomics.",
    link: "https://www.vergegenomics.com/",
    image: vergeGenomicsLogo
  },
  {
    name: "WellDoc",
    description:
      "The only FDA cleared healthcare intervention solution that has proven to reduce A1C levels for patients living with type 2 diabetes.",
    link: "https://www.welldoc.com/",
    image: wellDocLogo
  },
  {
    name: "Zephyr",
    description:"AI-enabled composite biomarkers for enhanced clinical development.",
    link: "https://www.zephyrai.bio/",
    image: zephyrLogo
  }
];

export default portfolio;
